import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const PathogenInfection = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5 py-4 bg-img' style={{ backgroundImage:'url("pathogen-testing/ULC-Testing-bg-v1.png")', width:'100%'}}>
            <Row className=''>
                <Col md='12' lg='7' className=''>
                    <div className=''>
                        <div className=''>
                            <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                                Infections Caused by Bacteria, such as COVID-19
                            </div>
                            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className='py-3 pe-md-5'>
                            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                            Pneumonia is caused by bacteria or whooping cough. If you have respiratory infection symptoms and are at risk for complications, you might need this test. The majority of respiratory infections result in mild to moderate symptoms. However, the conditions can be severe or even fatal for young children, and the elderly patients with compromised immune systems.
                            </div>
                        </div>

                        <div className='pt-2'>
                        <Link to='/book-panel-test-appointment'>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16-1' style={{ padding:'',}}>
                                    BOOK YOUR PANEL TEST
                                </text>
                            </Button>
                        </Link>
                        </div>
                    </div>
                </Col>
                <Col md='12' lg='' className=''>
                    <div className='flex-center'>
                        <img src='pathogen-testing/RPP-Testing-img1.png' alt='' className='img-w24' width='%' />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default PathogenInfection